import CognitoSignIn from './cognito-signin';
export default CognitoSignIn;
